import { Body, Heading } from '@e2n/ui/v2';
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function MitarbeiterErstellt() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4 items-center">
      <FontAwesomeIcon
        icon={faCircleCheck}
        className="size-12 text-primary-green-500"
      />
      <Heading>{t('domain.mitarbeiter.create.success.message')}</Heading>
      <Body>{t('domain.mitarbeiter.create.success.description')}</Body>
    </div>
  );
}
